import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-identificacao-cpf',
  templateUrl: './identificacao-cpf.component.html',
  styleUrls: ['./identificacao-cpf.component.scss']
})
export class IdentificacaoCpfComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
